import { useAuth } from "@agentech/auth-client";
import { useEffect, useState } from "react";
import { AuthStatusScreen } from "../components/AuthStatusScreen";

export function LogoutPage() {
  const { logout, isAuthenticated, isInitializing } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    if (isInitializing) return;
    if (isAuthenticated) {
      if (!isLoggingOut) {
        setIsLoggingOut(true);
        logout();
      }
      return;
    }
    // Already signed out (e.g. returned here from the Cognito /logout redirect) —
    // don't spin forever; send the user to sign-in.
    window.location.replace("/");
  }, [isInitializing, isAuthenticated, isLoggingOut, logout]);

  return (
    <AuthStatusScreen containerClassName="logout-container">
      <div className="loading-spinner" />
      <h2>Signing you out</h2>
      <p>Please wait while we sign you out.</p>
    </AuthStatusScreen>
  );
}
